<div class="app">
  <app-header></app-header>
  <div class="remaining-page">
    @if (showSidenav) {
      <app-sidenav class="open"></app-sidenav>
    }
    <main role="main" class="content-app">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

@if (loaderIsVisible) {
  <app-loader [message]="loaderMessage"></app-loader>
}
